import { createAction } from '@reduxjs/toolkit';

import { LOAD_SELLERS_INFO } from './actionTypes';

export const loadSellersInfo = createAction(LOAD_SELLERS_INFO.BASE);
